# Web components

The SEEK API has web-based components that you can integrate with your software.
For example, you can embed SEEK-built panels on your website to enable [ad selection] and [questionnaires],
or include a link to a SEEK-hosted page for [previewing a job ad].

Our panels are bundled into a unified [software development kit].
This makes it simple for your software to embed multiple panels,
while SEEK can enhance the panels over time with built-in support for beta testing and staged rollouts.

import { Actions, ButtonLink, IconArrow } from 'braid-design-system';

<Actions>
  <ButtonLink
    href="/introduction/panels"
    icon={<IconArrow direction="right" />}
    variant="soft"
  >
    Panels
  </ButtonLink>
</Actions>

All of our web-based components follow a documented browser support policy.
Hirers should use an up-to-date web browser to ensure that they can access the components and use all of their features.

<Actions>
  <ButtonLink
    href="/introduction/browser-support"
    icon={<IconArrow direction="right" />}
    variant="soft"
  >
    Browser support
  </ButtonLink>
</Actions>

[ad selection]: /use-cases/job-posting/ad-selection
[previewing a job ad]: /use-cases/job-posting/managing-job-ads/previewing-a-job-ad
[questionnaires]: /use-cases/job-posting/questionnaires
[software development kit]: https://en.wikipedia.org/wiki/Software_development_kit
